import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    'Authorization': `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getRoles = async (filter = {}) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Role/get`,
      filter,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching roles:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to fetch roles",
      error
    };
  }
};

export const saveRole = async (role) => {
  try {
    const formattedRole = {
      Role_Id: role.role_Id,
      Role_Name: role.role_Name?.trim(),
      Role_Active: role.role_Active
    };

    const saveResponse = await axios.post(
      `${BASE_URL}/api/Role/save`,
      formattedRole,
      {
        headers: getAuthHeader(),
      }
    );
    
    return {
      success: true,
      message: saveResponse.data.message || "Role saved successfully",
      data: saveResponse.data,
      roleId: saveResponse.data.roleId
    };
  } catch (error) {
    console.error("Error saving role:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to save role",
      error
    };
  }
};

export const getRolePermissions = async (roleId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/api/Role/permissions/${roleId}`,
      {
        headers: getAuthHeader(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching role permissions:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to fetch role permissions",
      error
    };
  }
};

export const saveRolePermissions = async (roleId, permissions) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Role/permissions/save`,
      {
        Role_Id: roleId,
        Permissions: permissions
      },
      {
        headers: getAuthHeader(),
      }
    );
    return {
      success: true,
      message: response.data.message || "Role permissions saved successfully"
    };
  } catch (error) {
    console.error("Error saving role permissions:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to save role permissions",
      error
    };
  }
};

export const checkRoleNameExists = async (roleName, excludeRoleId = null) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/api/Role/check-rolename`,
      {
        RoleName: roleName.trim(),
        ExcludeRoleId: excludeRoleId
      },
      {
        headers: getAuthHeader(),
      }
    );
    return response.data.exists;
  } catch (error) {
    console.error("Error checking role name:", error);
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to check role name",
      error
    };
  }
};
